import { render, staticRenderFns } from "./ProgramRegistrationPopup.vue?vue&type=template&id=c8e2e674&"
import script from "./ProgramRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./ProgramRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProgramRegistrationPopup.vue?vue&type=style&index=0&id=c8e2e674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports